import { useEffect, useState } from 'react';

export interface OnlineStatus {
  online: boolean;
  /** Timestamp en ms desde que se perdió la red. null si está online. */
  offlineSince: number | null;
}

function getInitialOnline(): boolean {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine;
}

export function useOnlineStatus(): OnlineStatus {
  const [online, setOnline] = useState<boolean>(getInitialOnline);
  const [offlineSince, setOfflineSince] = useState<number | null>(() =>
    getInitialOnline() ? null : Date.now(),
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onOnline = (): void => {
      setOnline(true);
      setOfflineSince(null);
    };
    const onOffline = (): void => {
      setOnline(false);
      setOfflineSince(Date.now());
    };
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return { online, offlineSince };
}
